<template>
  <div ref="selectField"
    v-if="readonly || (!isEditing && isAllowEditingMode)"
    class="displayField"
    :class="{ readonly }"
    :tabindex="readonly ? -1 : 0"
    @keydown.enter="setEditMode($refs.selectField)"
    @click="setEditMode($refs.selectField)"
  >
    <label>{{ label }}</label>
    <p class="value mt-2">{{ value }}</p>
    <div class="editIcon" v-if="!readonly">
      <v-icon size="20px">mdi-pencil</v-icon>
    </div>
  </div>
  <v-select
    v-else
    v-bind="$attrs"
    v-on="$listeners"
    v-model="value"
    :placeholder="placeholder"
    :outlined="outlined"
    :ref="uid"
    :label="label"
    class="ads-select"
  />
</template>

<script>
const isIe = () => {
  const ua = window.navigator.userAgent;
  // MSIE 10 or below || MSIE11.x
  return (
    ua.indexOf('MSIE') !== -1 || !!navigator.userAgent.match(/Trident.*rv:11\./)
  );
};

export default {
  name: 'AdsSelect',
  props: {
    placeholder: {
      type: String,
      default: ' ',   // override the default value 'undefined' in v-select
    },
    outlined: {
      type: Boolean,
      default: true   // override the default value 'false' in v-select
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    isAllowEditingMode: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    setEditMode: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      uid: `ads-select_${this._uid}`
    };
  },
  computed: {
    value: {
      get() {
        return this.$attrs.value;
      },
      set(value) {
        this.$listeners.input && this.$listeners.input(value);
      }
    },
  },
  created() {
    if (isIe()) {
      // Hack to prevent IE clearing of v-select
      this.$watch('value', function (newVal, oldVal) {
        // Prevent clearing of value
        if (oldVal && !newVal && newVal !== undefined) {
          this.$refs[this.uid].setValue(oldVal);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

::v-deep.v-list {
  .v-list-item {
    transition: background-color 0.3s ease-out;
  }

  .v-list-item.v-list-item--highlighted {
    border-collapse: separate; /* for ie 9-11 */
    box-shadow: 0px 0px 0px 3px $ads-blue-3-dark inset;

    &:before {
      opacity: 0;
    }
  }

  &.theme--light {
    .v-list-item.v-list-item--active {
      background-color: $ads-navy;
      color: $ads-white !important;
    }
  }

  &.theme--dark {
    .v-list-item.v-list-item--active {
      background-color: $ads-navy-dark;
      color: $ads-01dp !important;

      &:before {
        opacity: 0;
      }
    }
  }
}

label {
  color: $ads-primary-blue;
  font-size: 1rem;
  font-weight: 700;
}
.value {
  min-height: 1rem;
  color: $ads-grey-01;
}

.editIcon {
  position: absolute;
  top: 7px;
  right: 7px;
  display: none;
  &:focus {
    display: block;
    border: 2px solid $ads-navy;
  }
}

.displayField:not(.readonly) {
  position: relative;
  cursor: pointer;
  label {
    cursor: pointer;
  }
  &:hover,
  &:focus {
    background-color: $ads-grey-04;
    .editIcon {
      display: block;
    }
  }
}

.displayField.readonly {
  cursor: not-allowed;
  label {
    cursor: not-allowed;
  }
}

.isEditing .displayField {
  padding-top: 0px !important;
}
</style>
